import { useSelector } from 'react-redux';
import { getCookieByName } from '../utils/functions';

export function useEnableDigitalOptometry() {
  const enableDigitalOptometryCookie = getCookieByName(
    'enableDigitalOptometry',
    false
  );
  const enableDigitalOptometryConfig = useSelector(
    (state: any) => state.config.layoutSettings?.enableDigitalOptometry
  );
  const enableDigitalOptometryFlow = useSelector(
    (state: any) =>
      state.workflow.flowDefiningAttributes?.enableDigitalOptometry
  );

  if (
    enableDigitalOptometryCookie !== null &&
    enableDigitalOptometryCookie !== undefined
  ) {
    return enableDigitalOptometryCookie as boolean;
  }
  if (
    enableDigitalOptometryConfig !== null &&
    enableDigitalOptometryConfig !== undefined
  ) {
    return enableDigitalOptometryConfig as boolean;
  }
  if (
    enableDigitalOptometryFlow !== null &&
    enableDigitalOptometryFlow !== undefined
  ) {
    return enableDigitalOptometryFlow as boolean;
  }
  return false;
}
